// import Vue from 'vue'
const Vue = require('vue');
//import VueI18n from 'vue-i18n';
const VueI18n = require('vue-i18n');
// import ElementUI from 'element-ui';
const ElementUI = require('element-ui');

import App from './App.vue'
import globalVariablesPlugin from './plugins/globalVariables.js';
import router from './router';

Vue.use(globalVariablesPlugin);
Vue.use(VueI18n)
Vue.use(ElementUI)

const i18n = new VueI18n({
  locale: 'en', // 设置默认语言
  messages: {
    en: require('./locales/en.json'),
    zh: require('./locales/zh-CN.json')
  }
});

Vue.config.productionTip = false;

new Vue({
  el: '#app',
  i18n,
  router:router,
  render: h => h(App)
})


// WEBPACK FOOTER //
// ./src/main.js